import { autoinject } from 'aurelia-framework';
import { DataFilter, QueryFilter } from 'lib/tables/DataFilter';
import {
  CheckDuplicateMooringCertificate,
  CreateUpdateMooringCertificate,
  MooringCertificate,
  MooringCertificateListItem,
  SendMooringCertificates,
  SentToEmailHistory,
} from 'models/mooring';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class MooringCertificateService extends BaseApiService<MooringCertificate> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, MooringCertificate);
  }

  public async seach(query: string, erpSystemId: number, articleNumber: string = '') {
    return await this.httpClient.exec<MooringCertificateListItem[]>(
      `${MooringCertificate.ApiUrl}/search?query=${query}&erpSystemId=${erpSystemId}&articleNumber=${articleNumber}`,
      {
        method: 'GET',
      }
    );
  }

  public async table(filters: QueryFilter) {
    if (filters.export) {
      // const f = await this.httpClient.execNoTransform(`api/serviceInvoices/invoiceable${filters.toQueryString()}`, {
      //   method: 'GET',
      // });
      // return f.blob().then((blob) => {
      //   const dateString = new DateFormatValueConverter().toView(new Date(), 'DD-MM-YYYY');
      //   saveAs(blob, `service-invoiceable-report-${dateString}.xlsx`);
      // });
    } else {
      return await this.httpClient.execWithResponseMeta<MooringCertificateListItem[]>(
        `${MooringCertificate.ApiUrl}/table${filters.asQueryString}`,
        {
          method: 'GET',
        }
      );
    }
  }

  public async frameTable(filters: DataFilter) {
    return await this.httpClient.execWithResponseMeta<MooringCertificateListItem[]>(
      `${MooringCertificate.ApiUrl}/table/frame${filters.toQueryString()}`,
      {
        method: 'GET',
      }
    );
  }

  public async create(data: CreateUpdateMooringCertificate) {
    return await this.httpClient.exec<MooringCertificate>(`${MooringCertificate.ApiUrl}/create`, {
      method: 'POST',
      body: this.createFormData(data),
      headers: {},
    });
  }

  public async update(data: CreateUpdateMooringCertificate, id: number) {
    return await this.httpClient.exec<MooringCertificate>(`${MooringCertificate.ApiUrl}/${id}/update`, {
      method: 'PATCH',
      body: this.createFormData(data),
      headers: {},
    });
  }

  public async preview(id: number) {
    const response = await this.httpClient.fetch(`${MooringCertificate.ApiUrl}/${id}/preview`, {
      method: 'GET',
    });
    const fileName = `certificate-${id.toString().padStart(6, '0')}-preview.pdf`;
    return {
      blob: await response.blob(),
      fileName,
    };
  }

  public async approve(id: number) {
    return await this.httpClient.execNoTransform(`${MooringCertificate.ApiUrl}/${id}/approve`, {
      method: 'POST',
    });
  }

  public async checkDuplicate(data: CheckDuplicateMooringCertificate) {
    return await this.httpClient.exec<{ IsDuplicate: boolean }>(`${MooringCertificate.ApiUrl}/checkDuplicate`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  public async unlock(id: number) {
    return await this.httpClient.execNoTransform(`${MooringCertificate.ApiUrl}/${id}/unlock`, {
      method: 'POST',
    });
  }

  public async downloadSelectedCertificatesZip(certificateIds: number[]) {
    const response = await this.httpClient.execNoTransform(`${MooringCertificate.ApiUrl}/download-selected`, {
      method: 'POST',
      body: JSON.stringify({
        certificateIds,
        sendType: 0,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const contentDisposition = response.headers.get('content-disposition') || '';
    const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8''|\")?([^\";]+)/i);
    const fileName = fileNameMatch?.[1] ? decodeURIComponent(fileNameMatch[1].replace(/\"/g, '')) : 'sertifikater.zip';

    return {
      blob: await response.blob(),
      fileName,
    };
  }

  public async sendSelectedCertificates(data: SendMooringCertificates) {
    return await this.httpClient.execNoTransform(`${MooringCertificate.ApiUrl}/send-selected`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  private createFormData(data: CreateUpdateMooringCertificate) {
    const formData = new FormData();

    if (data.CertificateAttachment) {
      formData.append('CertificateAttachment', data.CertificateAttachment, data.CertificateAttachment.name);
    }
    if (data.DocumentationAttachments?.length) {
      data.DocumentationAttachments.forEach((file) => {
        formData.append('DocumentationAttachments', file, file.name);
      });
    }
    if (data.RemoveDocumentationAttachmentIds?.length) {
      data.RemoveDocumentationAttachmentIds.forEach((id) => {
        formData.append('RemoveDocumentationAttachmentIds', id.toString());
      });
    }

    Object.entries(data).forEach(([key, value]) => {
      if (key === 'CertificateAttachment' || key === 'DocumentationAttachments' || key === 'RemoveDocumentationAttachmentIds' || key === 'DocumentationAttachmentIds') return;
      if (typeof value == 'undefined' || value == '') return;
      if (value instanceof Date) {
        value = value.toISOString();
      }
      formData.append(key, value);
    });
    return formData;
  }

    public async getCertificateSentEmailHistory(id: number) {
    return await this.httpClient.execWithResponseMeta<SentToEmailHistory[]>(
      `${MooringCertificate.ApiUrl}/${id}/sent-email-history`,
      {
        method: 'GET',
      }
    );
  }
}
